"use client";

export default function DailyWealthRotationChart() {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-xl font-bold text-foreground mb-6">
        Daily Wealth Rotation Chart
      </h2>
      {/* Chart implementation goes here */}
    </div>
  );
}

